import templateUrl from './home-latest-progress-reports.html';

export const homeLatestProgressReportsComponent = {
	templateUrl,

	bindings: {
		details: '<',
		slugUrl: '@'
	},

	controller: class HomeLatestProgressReportsComponent {
		constructor(ApiService) {
			'ngInject';

			this.apiService = ApiService;
		}

		_getFileName(report) {
			const pdf = report.pdf;
			return pdf ? this.apiService.getResourceUrl(`files/pdf/${pdf}`) : report.url;
		}

		_getImage(report) {
			const image = report.image;
			return image ? this.apiService.getResourceUrl(`files/images/${image}`) : '';
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/components/home-latest-progress-reports/home-latest-progress-reports.component.js